module.exports = __webpack_public_path__ + "static/media/NuevoVallarta.1d1ea9ae.jpg";